import { blogPosts } from './generated'
import searchUrl from './generated/search.json?url&no-inline'

export interface BlogPost {
  lang: 'vi' | 'en'
  id: string
  slug: string
  date: string
  timestamp: string
  hashtags: string[]
  images: string[]
  firstLineVi: string
  excerptVi: string
  titleEn: string
  excerptEn: string
}

export interface BlogContent {
  contentVi: string
  contentEn: string
}

export { blogPosts }
export const blogPostBySlug = new Map(blogPosts.map(post => [post.slug, post]))
export const allHashtags = [...new Set(blogPosts.flatMap(post => post.hashtags))].sort()

const bodyUrls = import.meta.glob<string>('./generated/posts/*.json', {
  query: '?url&no-inline',
  import: 'default',
  eager: true,
})

export async function loadBlogContent(id: string, signal?: AbortSignal): Promise<BlogContent> {
  const url = bodyUrls[`./generated/posts/${id}.json`]
  if (!url) throw new Error('Post not found')
  const response = await fetch(url, { signal })
  if (!response.ok) throw new Error('Could not load article')
  return response.json()
}

export async function loadBlogSearch(signal?: AbortSignal): Promise<Record<string, string>> {
  const response = await fetch(searchUrl, { signal })
  if (!response.ok) throw new Error('Could not load search index')
  return response.json()
}
